import React from 'react';
import FormBuscadorReusable from '../buscadores/form-buscador-reusable';
import './packageSearcher.css';

export default function PackageSearcher() {
  return (
    <div className="package-searcher-container shadow-md rounded-lg md:rounded-md">
      <div className="package-searcher rounded-lg md:rounded px-5 py-5 md:px-4 md:py-3">
        <div className="seacher-form-container">
          <FormBuscadorReusable />
        </div>
      </div>
    </div>
  );
}
